import { createContext } from 'react';

import useNodeManager from './useNodeMangaer';

const NodeManagerContext = createContext({});

export const NodeManagerProvider = ({ children }) => {
  const contextApi = useNodeManager();
  return (
    <NodeManagerContext.Provider value={contextApi}>
      {children}
    </NodeManagerContext.Provider>
  );
};

export default NodeManagerContext;
